export const names = ['left', 'right', 'top', 'bottom', 'roof'] as const;
